<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">订单流水</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query">
        <el-form-item label="创建时间：">
          <el-date-picker @change="dateRangeChangFun"
                          v-model="dateRange"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          range-separator="-"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="title">
      <el-tooltip effect="dark" content="注意：需订单【收货】才会产生利润流水。利润：（商品费用-成本价）* 分佣比例" placement="top-start">
        <i class="el-icon-info">订单流水</i>
      </el-tooltip>
    </div>

    <div class="content-data">
      <el-table :data="assetDetail" highlight-current-row border>
        <el-table-column  align="center" type="index"/>
        <el-table-column label="订单编号" width="250px" align="center" prop="code"/>
        <el-table-column align="center" label="￥订单费用">
          <el-table-column label="订单总费用" align="center" prop="orderFee">
            <template slot-scope="scope">
              {{ scope.row.orderFee ? '￥' + scope.row.orderFee : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="商品总费用" align="center" prop="goodsFee">
            <template slot-scope="scope">
              {{ scope.row.goodsFee ? '￥' + scope.row.goodsFee : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="商品总成本价" align="center" prop="goodsCostPrice">
            <template slot-scope="scope">
              {{ scope.row.goodsCostPrice ? '￥' + scope.row.goodsCostPrice : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="优惠费用" align="center" prop="freeFee">
            <template slot-scope="scope">
              {{ scope.row.freeFee ? '￥' + scope.row.freeFee : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="总运费" align="center" prop="freightFee">
            <template slot-scope="scope">
              {{ scope.row.freightFee ? '￥' + scope.row.freightFee : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="用户支付金额" align="center" prop="payFee">
            <template slot-scope="scope">
              {{ scope.row.payFee ? '￥' + scope.row.payFee : '\\' }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="￥分润详情">
          <el-table-column label="经理分润费用" align="center" prop="managerProfitFee">
            <template slot-scope="scope">
              {{ scope.row.managerProfitFee ? '￥' + scope.row.managerProfitFee : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="团长分润费用" align="center" prop="leaderProfitFee">
            <template slot-scope="scope">
              {{ scope.row.leaderProfitFee ? '￥' + scope.row.leaderProfitFee : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="一级分佣费用" align="center" prop="firstParentFee">
            <template slot-scope="scope">
              {{ scope.row.firstParentFee ? '￥' + scope.row.firstParentFee : '\\' }}
            </template>
          </el-table-column>
          <el-table-column label="二级分佣费用" align="center" prop="secondParentFee">
            <template slot-scope="scope">
              {{ scope.row.secondParentFee ? '￥' + scope.row.secondParentFee : '\\' }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>

    <vue-pager v-bind:datafile="fillData" url="orderProfitFee/pageOrderProfitFee" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
  </div>
</template>
<script>
export default {
  data() {
    return {
      assetDetail: [],
      query: {
        orderStatus: "RECEIVED",
        orderFeeType: "COMMON"
      },
      total: {},
      orderFeeTypeMap: {},
      dateRange: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '当天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },

    }
  },
  created() {
    var _this = this;
    _this.$set(_this.query, 'assetType', _this.$route.query.assetType);

    let orderFeeType = _this.$common.enum_config('EOrderFeeType');
    orderFeeType.forEach((item) => {
      _this.orderFeeTypeMap[item.name] = item.label;
    });

  },
  methods: {
    dateRangeChangFun(e) {
      if (e) {
        this.$set(this.query, 'startTime', e[0]);
        this.$set(this.query, 'endTime', e[1]);
      } else {
        this.$set(this.query, 'startTime', null);
        this.$set(this.query, 'endTime', null);
      }
    },
    fillData(_response) {
      var _this = this;
      _this.assetDetail = _response.items || [];
    },
    submitQuery(_num) {
      var _this = this;

      _this.assetDetail = [];
      _this.$refs.pager.gotoPage(_num);
    },
  },

}
</script>
<style scoped>
.yuan {
  font-size: 18px;
  padding: 5px 0;
  font-weight: 600;
}

.colorgreen {
  color: #22ca18;
}

.colorrad {
  color: #fb0101;
}

.tong {
  width: 40%
}

.table td {
  text-align: center;
}
</style>
